import React from 'react';
import TechnologyAnimate from './TechnologyAnimate';
import styled from 'styled-components';
import { HomeAboutTechnology } from '../../../../types/globalTypes';
import { Text, Title } from '../../../../components';
import {
  COLORS,
  ABOUT_US_TITLE,
  device,
  FONTS,
  ROUTES,
} from '../../../../constants';
import { NavLink as Link } from 'react-router-dom';
import { MotionText } from '../../../../components/Motion';

interface TechnologyProps {
  technologyInfo: HomeAboutTechnology;
}

const Technology = ({ technologyInfo }: TechnologyProps) => {
  return (
    <TechnologyWrapper>
      <TechnologyText>
        <Title
          title={technologyInfo.Title}
          fontFamily={FONTS.TITLE}
          size={36}
          lineHeight={46}
          color={COLORS.SECTION_TITLE}
        />
        <TechnologyDescription>
          <TextWrapper>
            {technologyInfo.Subtitle.split('\n').map((item, index) => (
              <Text
                key={index}
                text={item}
                fontFamily={FONTS.SUBTITLE}
                size={22}
                lineHeight={28}
                color={COLORS.SECTION_TEXT}
              />
            ))}
          </TextWrapper>
          <StyledLink to={ROUTES.ABOUT}>{ABOUT_US_TITLE}</StyledLink>
        </TechnologyDescription>
      </TechnologyText>
      <TechnologyAnimateWrapper>
        <TechnologyAnimate />
      </TechnologyAnimateWrapper>
    </TechnologyWrapper>
  );
};
const TechnologyText = styled(MotionText)`
  max-width: 700px;
  > span {
    display: block;
    margin-bottom: 60px;
  }
  @media screen and ${device.bsm} {
    > span {
      margin-bottom: 20px;
      font-size: 25px;
      line-height: 30px;
    }
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 0;
  @media screen and ${device.lg} {
    > h4 {
      font-size: 16px;
      line-height: 20px;
    }
    gap: 10px;
  }
`;
const TechnologyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 100px;
  @media screen and ${device.lg} {
    gap: 50px;
  }
  @media screen and ${device.bsm} {
    flex-direction: column-reverse;
    gap: 20px;
  }
`;
const TechnologyDescription = styled.div`
  > div {
    margin-bottom: 40px;
  }
  @media screen and ${device.sm} {
    > div {
      margin-bottom: 20px;
    }
  }
`;
const TechnologyAnimateWrapper = styled.div`
  width: 728px;
  height: 728px;
  position: relative;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and ${device.lg} {
    width: 485px;
    height: 485px;
  }
  @media screen and ${device.md} {
    width: 243px;
    height: 243px;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-color: ${COLORS.MAIN_RED};
  color: ${COLORS.WHITE};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 0;
  width: 130px;
  height: 55px;
  font-family: ${FONTS.SUBTITLE};
  &:hover {
    background: ${COLORS.RED_HOVER};
  }
  &:active {
    background: ${COLORS.RED_PRESSED};
  }
  @media screen and ${device.md} {
    margin: 0;
  }
  @media screen and ${device.sm} {
    text-align: center;
    margin: 15px auto;
  }
`;
export default Technology;
